import axiosIns from '@axiosIns'
import Vue from 'vue'

/**
 * Génère les données nécessaires pour InitialsAvatar
 * @param {object|null} user L'objet utilisateur { firstName, lastName, userName }
 * @returns {{familyName: string, givenName: string, fullName: string}}
 */

function generateAvatarData(user) {
  if (!user || (!user.firstName && !user.lastName && !user.userName)) {
    return {
      familyName: 'I',
      givenName: 'N',
      fullName: 'Inconnu',
    }
  }

  let familyName = user.lastName || ''
  let givenName = user.firstName || ''
  let fullName = ''

  if (familyName && familyName !== '?' && givenName && givenName !== '?') {
    fullName = `${familyName} ${givenName}`
  } else if (user.userName && user.userName !== 'Inconnu') {
    fullName = user.userName
    const [fn, gn = user.userName] = user.userName.split(' ')
    familyName = fn
    givenName = gn
  } else {
    familyName = 'I'
    givenName = 'N'
    fullName = 'Inconnu'
  }

  return {
    familyName,
    givenName,
    fullName,
  }
}

export default {
  namespaced: true,
  state: {
    events: [],
    usersAvailable: [],
  },
  getters: {
    getAvailableUser: (state, getters) => id => {
      if (!id) { return null }
      const user = getters.usersAvailable.find(u => u.id === id)
      return user ?? {
        id, firstName: '?', lastName: '?', userName: 'Inconnu',
      }
    },
    getUserFullName: (state, getters) => id => {
      const user = getters.getAvailableUser(id)
      if (!user) { return 'Inconnu' }
      if (user.firstName && user.firstName !== '?' && user.lastName && user.lastName !== '?') {
        return `${user.lastName} ${user.firstName}`
      }
      return user.userName || 'Inconnu'
    },
    events: (state, getters) => state.events.map(event => {
      const user = getters.getAvailableUser(event.userId)
      const avatarData = generateAvatarData(user)

      return {
        ...event,
        endDate: new Date(event.end),
        startDate: new Date(event.start),
        title: avatarData.fullName,
        extendedProps: {
          ...event.extendedProps,
          avatar: avatarData,
          userId: event.userId,
        },
      }
    }),
    getEvent: getters => id => getters.events.find(event => event.id === id),
    usersAvailable: state => state.usersAvailable,
  },
  mutations: {
    addEvent(state, event) {
      state.events.push(event)
    },
    deleteEvent(state, id) {
      state.events = state.events.filter(e => e.id !== id)
    },
    updateEvent(state, event) {
      const index = state.events.findIndex(e => e.id === event.id)
      Vue.set(state.events, index, event)
    },
    setEvents(state, events) {
      state.events = events
    },
    setAvailableUsers(state, users) {
      state.usersAvailable = users
    },
  },
  actions: {
    fetchEvents(ctx, { start, end }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('Event', { params: { start, end } })
          .then(response => {
            ctx.commit('setEvents', response.data)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchUsersAvailable({ commit }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('Event/AvailableUsers')
          .then(response => {
            commit('setAvailableUsers', response.data)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    addEvent(ctx, event) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('Event', event)
          .then(response => {
            ctx.commit('addEvent', response.data)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    updateEvent(ctx, event) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put('Event', event)
          .then(response => {
            ctx.commit('updateEvent', event)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    removeEvent(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns.delete(`Event/${id}`)
          .then(response => {
            ctx.commit('deleteEvent', id)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
  },
}
